import { useCallback, useSyncExternalStore } from 'react';

const hosts = new Map<string, HTMLDivElement>();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Each split view owns its viewport below the header and beside the right pane. */
export function setWorkspaceNavigationHost(
  viewId: string,
  host: HTMLDivElement | null
) {
  if (hosts.get(viewId) === host || (!host && !hosts.has(viewId))) return;
  if (host) hosts.set(viewId, host);
  else hosts.delete(viewId);
  listeners.forEach(listener => listener());
}

export function useWorkspaceNavigationHost(viewId: string) {
  const snapshot = useCallback(() => hosts.get(viewId) ?? null, [viewId]);
  return useSyncExternalStore(subscribe, snapshot, () => null);
}
